import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import CircularProgress from '@material-ui/core/CircularProgress'
import pick from '../utilities/pick'
import mapDispatchers from '../utilities/mapDispatchers'
import styles from './BottomNavBar.icss'

class BottomNavBar extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			value: props.value,
			showLoader: false,
			hasHandledClick: false
		}
		this.handleChange = this.handleChange.bind(this)
	}

	static getDerivedStateFromProps(props) {
		return { value: props.value }
	}

	componentDidUpdate() {
		if (!this.props.nextButtonIsLoading && this.state.showLoader && !this.state.hasHandledClick) {
			this.props.handleClick(this.state.value)
		} else if (this.props.nextButtonIsLoading && !this.state.showLoader) {
			this.setState({ showLoader: true }) // eslint-disable-line react/no-did-update-set-state
		}
		if (!this.props.nextButtonIsLoading && this.state.showLoader) {
			this.setState({ showLoader: false }) // eslint-disable-line react/no-did-update-set-state
		}
	}

	handleChange(e, value) {
		this.setState({ value, showLoader: !!this.props.nextButtonIsLoading, hasHandledClick: !this.props.nextButtonIsLoading })
		if (!this.props.nextButtonIsLoading) {
			this.props.handleClick(value)
		}
	}

	render() {
		return (
			<div className={styles.appBarSurround}>
				<BottomNavigation
					onChange={this.handleChange}
					className={styles.appBar}
					value={this.state.value}
				>
					<BottomNavigationAction
						label={this.state.showLoader ?
							<span className={styles.loadingSurround}><CircularProgress className={styles.loading} size={24} thickness={4} /></span> :
							<span><span className={styles.text}>{this.props.labelNext}</span><ChevronRightIcon /></span>
						}
						classes={{ root: styles.button, selected: styles.selectedButton, label: styles.label }}
						style={{ flex: 'inherit' }}
					/>
				</BottomNavigation>
			</div>
		)
	}
}

BottomNavBar.propTypes = {
	value: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	handleClick: PropTypes.func.isRequired,
	nextButtonIsLoading: PropTypes.bool,
	labelNext: PropTypes.string.isRequired
}

BottomNavBar.defaultProps = {
	nextButtonIsLoading: undefined
}

BottomNavBar.contextTypes = {
	translate: PropTypes.func
}

export const testing = {
	BottomNavBar
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user', 'nextButtonIsLoading']),
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['appRedirect'])
)(BottomNavBar)



// WEBPACK FOOTER //
// ./src/components/BottomNavBar.jsx